import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import { getLang } from '../utils'

export function RegionSelector({
  value,
  onChange,
  loadRegions = searchRegions,
  ...props
}) {
  const [items, setItems] = useState()

  useEffect(() => {
    init()
  }, [])
  async function init() {
    const res = await loadRegions()
    setItems(res)
  }

  if (!items) return null

  return (
    <Select
      {...props}
      key="regions"
      showSearch
      style={{ width: '100%' }}
      placeholder="Please select a region"
      defaultValue={value?.length ? value : undefined}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      onChange={onChange}
    >
      {items.map((item) => (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      ))}
    </Select>
  )
}

export async function searchRegions() {
  const lang = getLang(new URL(window.location.href))
  const obj = await fetch(
    `/db/guillotina/@list-id-zonas?lang=${lang}`
  ).then((res) => res.json())
  return obj?.zonas
    ?.filter(
      (item) => item.type !== 'supraregion' && item.type !== 'subdivision'
    )
    ?.map?.((item) => ({ id: item.path, name: item.name }))
}
